import { createRouter, createWebHashHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "home",
    // component: () => import('../views/layout'),
    redirect: "/home",
    children: [
      {
        path: "/home",
        // name: "home",
        component: () => import("../views/home/index.vue"),
      },
      {
        path: "/security",
        name: "security",
        component: () => import("@/views/security/index.vue"),
      },

      //测试word
      {
        path: "/word-test",
        name: "word-test",
        component: () => import("@/views/word-test/word.vue"),
      },




      // {
      //   path: '/contingencyplan',
      //   name: '应急预案生成',
      //   component: () => import('../views/contingencyplan/index.vue')
      // },
      // {
      //   path: '/administrative_penalty',
      //   // name: '行政处罚决策辅助',
      //   name: 'administrative_penalty',
      //   component: () => import('../views/administrative_penalty/index.vue')
      // },
    ],
  },
  // 安全监管智能助手
  {
    path: "/aiEnforcement",
    name: "aiEnforcement",
    component: () => import("../views/aiEnforcement/index.vue"),
  },
  {
    path: "/aiEnforcementLawDocument",
    name: "aiEnforcementLawDocument",
    component: () =>
      import("../views/aiEnforcement/aiEnforcementLawDocument/index.vue"),
  },
  // 危险化学品特性
  {
    path: "/aiChemicalProperty",
    name: "aiChemicalProperty",
    component: () => import("../views/aiChemicalProperty/index.vue"),
  },
  {
    path: "/safeLabel",
    name: "safeLabel",
    component: () => import("../views/aiChemicalProperty/safeLabel/index.vue"),
  },
  // 事故案例智能查询
  {
    path: "/accidentSafety",
    name: "accidentSafety",
    component: () => import("../views/accidentSafety/index.vue"),
  },
  {
    path: "/accidenDocument",
    name: "accidenDocument",
    component: () =>
      import("../views/accidentSafety/accidenDocument/index.vue"),
  },
  // 法规标准库
  {
    path: "/document",
    name: "document",
    component: () => import("../views/document/index.vue"),
  },
  {
    path: "/lawDecode",
    name: "lawDecode",
    component: () => import("../views/document/lawDecode/index.vue"),
  },
  {
    path: "/pdf_preview2",
    name: "preview2",
    component: () => import("../views/pdf_preview2/index.vue"),
  },
  // 安全智库
  {
    path: "/safeStore",
    name: "safeStore",
    component: () => import("../views/safeStore/index.vue"),
  },
  {
    path: "/safeStoreDocument/:folder_level_1/:folder_level_2",
    name: "safeStoreDocument",
    component: () => import("../views/safeStore/safeStoreDocument/index.vue"),
  },
  {
    path: "/safeStoreDocumentPreview/:folder_level_1/:folder_level_2/:filename",
    name: "safeStoreDocumentPreview",
    component: () =>
      import("../views/safeStore/safeStoreDocumentPreview/index.vue"),
  },
  // 我的私人助理
  {
    path: "/user",
    name: "user",
    component: () => import("../views/user/index.vue"),
  },
  // 登录注册
  {
    path: "/login",
    name: "login",
    component: () => import("../views/login/index.vue"),
  },
  // pdf预览
  {
    path: "/pdf_preview",
    name: "preview",
    component: () => import("../views/pdf_preview/index.vue"),
  },
  //私人助理上传文件预览
  {
    path: "/user_preview",
    name: "user_preview",
    component: () => import("../views/user_preview/index.vue"),
  },
  // doc预览
  {
    path: "/doc_preview/:file_name/:file_type?",
    name: "doc_preview",
    component: () => import("../views/doc_preview/index.vue"),
  },
  {
    path: "/test",
    name: "test",
    component: () => import("../views/test/index.vue"),
  },
  {
    path: "/editinfo",
    name: "editinfo",
    component: () => import("../views/editinfo/index.vue"),
  },
  {
    path: "/wxphone/:openid?",
    name: "wxphone",
    component: () => import("../views/wxphone/index.vue"),
  },
  // 应急预案生成
  {
    path: "/emergencyPlan",
    name: "EmergencyPlan",
    component: () => import("../views/EmergencyPlan/index.vue"),
    children:[
      {
        path: "planeInfo/:step/:documentId",
        name: "PlaneInfo",
        meta: {title: "应急预案详情"},
        component: () => import("../views/EmergencyPlan/planeInfo.vue"),
      },
      {
        path: "EmergencyPreparedness",
        name: 'EmergencyPreparedness',
        meta: {title: "应急准备"},
        component: () => import('../views/EmergencyPlan/EmergencyPreparedness/index.vue')
      },
      {
        path: "emergencyExercise",
        name: "EmergencyExercise",
        meta: {title: "应急预案详情"},
        component: () => import("../views/EmergencyPlan/EmergencyExercise/index.vue"),
      },
      {
        path: 'EmergencyResponse',
        name: 'EmergencyResponse',
        meta: {title: "应急预案详情"},
        component: () => import('../views/EmergencyPlan/EmergencyResponse/index.vue')
      },
      {
        path: "emergencyPlanReview",
        name: "EmergencyPlanReview",
        meta: {title: "应急预案详情"},
        component: () => import("../views/EmergencyPlan/EmergencyPlanReview/index.vue"),
      },
    ]
  },
  // 化学品矩阵
  {
    path: "/chemicalmatrix",
    name: "chemicalmatrix",
    component: () => import("../views/chemicalMatrix/index.vue"),
  },
  // 风险评估
  {
    path: "/riskControl",
    name: "RiskControl",
    component: () => import("../views/riskControl/Layout.vue"),
    redirect: "/riskControl/home",
    children: [
      {
        path: "home",
        name: "RiskControlHome",
        component: () => import("../views/riskControl/Home.vue"),
      },
      {
        path: "list",
        name: "RiskControlList",
        component: () => import("../views/riskControl/List.vue"),
      },
      {
        path: "analysis",
        name: "RiskControlAnalysis",
        component: () => import("../views/riskControl/Analysis.vue"),
      },
      {
        path: "distribution",
        name: "RiskControlDistribution",
        component: () => import("../views/riskControl/Distribution.vue"),
      },
      {
        path: "library",
        name: "RiskControlLibrary",
        component: () => import("../views/riskControl/Library.vue"),
      },
      {
        path: "setting",
        name: "RiskControlSetting",
        component: () => import("../views/riskControl/Setting.vue"),
      },
      {
        path: "",
        redirect: "home"
      }
    ]
  },

];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
